import React, { useMemo, useState } from "react";
import styles from "./ui.module.scss";
import { useEventStore } from "../../store";
import { TUser } from "../../../../stores/EventStore";
import UserAvatar from "../../../ui/userAvatar";
import UserBloodType from "../../../ui/userBloodType";
import UserDonorClass from "../../../ui/userDonorClass";

export const EventMobileJoinedUsers = () => {
  const { eventData, setIsModalOpen } = useEventStore();
  const [isMore, setIsMore] = useState(false);

  const { joined_users } = eventData;

  const lastLength = useMemo(() => {
    if (joined_users.length) return joined_users.length - 8;
  }, [joined_users, eventData]);

  if (!joined_users.length) return null;

  if (joined_users.length > 8) {
    if (!isMore) setIsMore(true);
  }

  return (
    <div className={styles.GlobalEventMobileJoinedUsers}>
      <div
        className={styles.EventMobileJoinedUsers}
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        <div className={styles.EventMobileJoinedUsers_Header}>
          <div className={styles.EventMobileJoinedUsers_Header_Text}>
            {eventData.type === "past" ? "Кто ходил" : "Кто уже идет"}
          </div>
          <div className={styles.EventMobileJoinedUsers_Header_Image}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.75 12H20.25"
                stroke="#4E5355"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.5 5.25L20.25 12L13.5 18.75"
                stroke="#4E5355"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className={styles.EventMobileJoinedUsers_Content}>
          {joined_users.slice(0, 8).map((user) => {
            return (
              <UserAvatar
                key={user.user.id}
                style={{ width: "auto", marginRight: "initial" }}
                user={user.user}
                scale={40}
              />
            );
          })}
          {isMore && !!lastLength && (
            <div className={styles.EventMobileJoinedUsers_Content_Mores}>
              +{lastLength}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const ModalEventJoinedUsers = () => {
  const { eventData, setIsModalOpen } = useEventStore();

  if (!eventData?.joined_users?.length) return null;

  const onClick = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={styles.ModalEventJoinedUsers}>
      <div className={styles.ModalEventJoinedUsers_Header}>
        <div className={styles.ModalEventJoinedUsers_Header_Text}>
          {eventData.type === "past" ? "Кто ходил" : "Кто уже идет"}
        </div>
        <div
          className={styles.ModalEventJoinedUsers_Header_Image}
          onClick={onClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M1 17L17 1M1 1L17 17L1 1Z"
              stroke="#4E5355"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
      <div className={styles.ModalEventJoinedUsers_Content}>
        <div className={styles.ModalEventJoinedUsers_Content_List}>
          {eventData.joined_users.map((item) => (
            <UserCard user={item.user} key={item.user.id} />
          ))}
        </div>
      </div>
    </div>
  );
};

const EventJoinedUsers = () => {
  const { eventData, eventTimeSlots } = useEventStore();

  if (!eventData?.joined_users?.length) return null;

  const reducer = (prev, curr) => prev + curr;

  const totalCount = eventTimeSlots.map((item) => item.count).reduce(reducer);

  return (
    <div className={styles.EventJoinedUsers}>
      <div className={styles.EventJoinedUsers_Header}>
        <div className={styles.EventJoinedUsers_Header_Text}>
          {eventData.type === "past" ? "Кто ходил" : "Кто уже идет"}
        </div>
        <div className={styles.EventJoinedUsers_Header_Count}>
          {eventData?.joined_count || 0}/{totalCount}
        </div>
      </div>
      <div className={styles.EventJoinedUsers_List}>
        {eventData.joined_users.map((item) => (
          <UserCard user={item.user} key={item.user.id} />
        ))}
      </div>
    </div>
  );
};

export const UserCard: React.FC<TUser> = ({ user }) => {
  return (
    <div className={styles.EventJoinedUsers_List_User}>
      <div className={styles.EventJoinedUsers_List_User_Left}>
        <UserAvatar user={user} style={{ marginBottom: "4px" }} scale={40} />
        <UserBloodType user={user} style={{ backgroundColor: "white" }} />
      </div>
      <div className={styles.EventJoinedUsers_List_User_Right}>
        <span>{user.first_name}</span>
        <UserDonorClass user={user} />
      </div>
    </div>
  );
};

export default EventJoinedUsers;
